import PropTypes from 'prop-types';
import { Box, Paper, Typography } from '@mui/material';
import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const TokenUsageAndCostChart = ({ data = [] }) => {
  const chartData = (data || []).map((item) => ({
    module: item.module,
    inputTokens: item.total_input_tokens || 0,
    outputTokens: item.total_output_tokens || 0,
    totalCost: item.total_cost || 0,
  }));

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 3,
        borderRadius: 2,
        width: '100%',
        boxSizing: 'border-box'
      }}
    >
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" fontWeight={600}>
          Token Volume & Total Spend
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Input and output token counts stacked by module with total cost ($)
        </Typography>
      </Box>

      <Box sx={{ width: '100%', height: 320 }}>
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart
            data={chartData}
            margin={{ top: 20, right: 20, left: 10, bottom: 20 }}
            barCategoryGap="35%"
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e0e0e0" />

            <XAxis dataKey="module" tick={{ fontSize: 12, fill: '#666' }} />

            <YAxis
              yAxisId="tokens"
              orientation="left"
              tick={{ fontSize: 12, fill: '#666' }}
              tickFormatter={(val) => `${(val / 1000).toFixed(0)}k`}
            />

            <YAxis
              yAxisId="cost"
              orientation="right"
              tick={{ fontSize: 12, fill: '#ed6c02' }}
              tickFormatter={(val) => `$${val.toFixed(2)}`}
            />

            <Tooltip
              formatter={(value, name) => {
                if (name === 'Total Cost') return [`$${Number(value).toFixed(2)}`, name];
                return [`${Number(value).toLocaleString()} tokens`, name];
              }}
            />

            <Legend wrapperStyle={{ paddingTop: 10 }} />

            <Bar
              yAxisId="tokens"
              dataKey="inputTokens"
              name="Input Tokens"
              stackId="tokens"
              fill="#2e7d32"
              barSize={40}
            />
            <Bar
              yAxisId="tokens"
              dataKey="outputTokens"
              name="Output Tokens"
              stackId="tokens"
              fill="#7b1fa2"
              radius={[4, 4, 0, 0]}
              barSize={40}
            />

            <Line
              yAxisId="cost"
              type="monotone"
              dataKey="totalCost"
              name="Total Cost"
              stroke="#ed6c02"
              strokeWidth={3}
              dot={{ r: 5, fill: '#ed6c02' }}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
};

TokenUsageAndCostChart.propTypes = {
  data: PropTypes.array.isRequired,
};

export default TokenUsageAndCostChart;